const addonData = [

    {
        id: 0,
        selected: false,
        feature: "Online Service",
        discription: "Acces to multiplayer games",
        monPrice: 1,
        yrPrice: 10

    },
    {
        id: 1,
        selected: false,
        feature: "Larger Storage",
        discription: "Extra 1TB cloud save",
        monPrice: 2,
        yrPrice: 20

    },
    {
        id: 2,
        selected: false,
        feature: "Custimizable Profile",
        discription: "Custom theme on your profile",
        monPrice: 2,
        yrPrice: 20

    }

]

export  default addonData